import {Component, OnInit} from '@angular/core';
import {ThemeService} from "../services/theme.service";
import {Observable} from "rxjs";
import {Option} from "../interfaces/theme-option.interface";

@Component({
  selector: 'app-controls-sample',
  templateUrl: './controls-sample.component.html',
  styleUrls: ['./controls-sample.component.css']
})
export class ControlsSampleComponent implements OnInit {
  options$: Observable<Array<Option>> = this.themeService.getThemeOptions();

  constructor(private readonly themeService: ThemeService) {
  }

  ngOnInit(): void {

  }

  themeChangeHandler(themeToSet: any) {
    this.themeService.set(themeToSet);
  }
}
